import { ConfirmationModal } from 'modules/ui';
import './Replies.scss';
import { DeskControllerBase } from '../DeskControllerBase';
export class RepliesController extends DeskControllerBase {
    static $inject = ['application', '$scope', 'SegmentService', 'DeskConfigurationService', 'LoadingService', 'RepliesService', 'ModalService', '$translate', 'ngToast'];
    constructor(application, $scope, SegmentService, DeskConfigurationService, LoadingService, RepliesService, ModalService, $translate, ngToast) {
        'ngInject';
        super(application, LoadingService, DeskConfigurationService, $scope);
        this.application = application;
        this.$scope = $scope;
        this.SegmentService = SegmentService;
        this.DeskConfigurationService = DeskConfigurationService;
        this.LoadingService = LoadingService;
        this.RepliesService = RepliesService;
        this.ModalService = ModalService;
        this.$translate = $translate;
        this.ngToast = ngToast;
        this.categories = [];
        this.isLoading = false;
    }
    async $onInit() {
        this.contenDeletedSuccessMsg = await this.$translate('utils.successMsg.33');
        try {
            this.LoadingService.startLoading();
            const { items } = await this.RepliesService.getAllCategories();
            this.categories = items;
        }
        catch (e) {
            this.categories = [];
            console.error(e);
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    async confirmDelete(item) {
        const modalTitle = await this.$translate('modules.application.detail.attendance.replies.category.delete.title');
        const modalBody = await this.$translate('modules.application.detail.attendance.replies.category.delete.body');
        const yes = await this.$translate('utils.misc.yes');
        const no = await this.$translate('utils.misc.no');
        const modal = await this.ModalService.showModal(ConfirmationModal({
            title: {
                text: modalTitle,
            },
            body: modalBody,
            buttons: {
                confirm: {
                    text: yes,
                },
                cancel: {
                    text: no,
                },
            },
        }));
        const confirmation = await modal.close;
        if (confirmation) {
            this.RepliesService.delete(item.id);
            this.categories = this.categories.filter(c => c.id !== item.id);
            this.ngToast.success(this.contenDeletedSuccessMsg);
        }
    }
    createNewCategoryTrack() {
        this.SegmentService.createBotTrack('helpdesk-custom-replies-category-created', this.application);
    }
}
RepliesController.$inject = ['application', '$scope', 'SegmentService', 'DeskConfigurationService', 'LoadingService', 'RepliesService', 'ModalService', '$translate', 'ngToast'];
